import $ from "jquery"; // Import jQuery
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import useFocusedRowHighlight from "../../../../hooks/useFocusedRowHighlight";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const Create = () => {
  const { checkRequiredFields } = useRequiredFields();
  const { getRowProps } = useFocusedRowHighlight();
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 100000,
    total: 0,
    last_page: 1,
  });

  const [inputs, setInputs] = useState({
    receipt_no: "",
    production_work_order_id: "",
    date: "",
    receive_date: "",
    entry_date: new Date().toISOString().split("T")[0],
    copy_type: "",
    purchase_type: "",
    from_department: "",
    to_department: "",
    to_department_id: "",
    status: "incomplete",
    remarks: "",
  });

  const [fromDepartmentArtId, setFromDepartmentArtId] = useState(null);

  const [list, setList] = useState([]);
  const [error, setError] = useState({});
  // const [product, setProduct] = useState([]);
  const [planningOptions, setPlanningOptions] = useState([]);
  const [role, setRole] = useState("");
  const [itemLoading, setItemLoading] = useState(false);
  const [receiveData, setReceiveData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // const [departments, setDepartments] = useState([
  //   { id: 1, name: "BODY", user_type: "body" },
  //   { id: 2, name: "JIGGER", user_type: "jigger" },
  //   { id: 3, name: "CASTING", user_type: "casting" },
  //   { id: 4, name: "FINISHING", user_type: "finishing" },
  //   { id: 5, name: "BK", user_type: "bk" },
  //   { id: 6, name: "GLAZING", user_type: "glazing" },
  //   { id: 7, name: "GK", user_type: "gk" },
  //   { id: 8, name: "SELECTION", user_type: "selection" },
  //   { id: 9, name: "DECORATION LOCAL", user_type: "decoration_local" },
  //   { id: 10, name: "DECORATION EXPORT", user_type: "decoration_export" },
  //   { id: 11, name: "DFW", user_type: "dfw" },
  //   { id: 12, name: "PACKING LOCAL", user_type: "packing_local" },
  //   { id: 13, name: "PACKING EXPORT", user_type: "packing_export" },
  //   { id: 14, name: "DSTORE", user_type: "dstore" },
  //   { id: 15, name: "GSTORE", user_type: "gstore" },
  //   { id: 16, name: "MOULD", user_type: "mould" },
  //   { id: 17, name: "PSTORE", user_type: "pstore" },
  //   { id: 18, name: "PLANNING", user_type: "planning" },
  //   { id: 19, name: "SAGGER", user_type: "sagger" },
  // ]);

  // const defectTypes = ["BN", "IS", "PH", "GD", "UG"];
  // const repairTypes = ["PH", "SS", "AIR", "PC"];

  // Fetch the requisition data by ID and populate the form inputs
  // const fetchData = () => {
  //   Http.get("/product-list/all").then((res) => {
  //     setProduct(res.data);
  //   });

  //   Http.get("/staff-type-check").then((res) => {
  //     setRole(res.data);
  //   });

  //   Http.get("/planning")
  //     .then((res) => {
  //       setPlanningOptions(res.data); // Set planning options
  //     })
  //     .catch((e) => {
  //       console.error("Error fetching planning options:", e);
  //     });
  // };
  console.log(inputs, "inputs");
  const fetchData = async () => {
    setLoading(true);
    try {
      // const resProduct = await Http.get("/product-list/all");
      // setProduct(resProduct.data);

      const resRole = await Http.get("/staff-type-check");
      setRole(resRole.data);

      const redData = await Http.get("/requisition-art-details/" + id);
      // (redData.data);
      setInputs((prevInputs) => ({
        ...prevInputs,
        planning_id: redData.data.planning_id, // Assuming the ID field for planning
        shift: redData.data.shift,
        receipt_no: redData.data.receipt_no,
        to_department_id: redData.data.from_department_art_id,
      }));

      // Store from_department_art_id in state
      setFromDepartmentArtId(redData.data.from_department_art_id);

      // Call handlePlanningChange with the planning_id from redData
      // This will now directly fetch from requisition-art-details
      handlePlanningChange(redData.data.planning_id);

      // Fetch planning options for the dropdown
      const resPlanning = await Http.get("/planning");
      const planningData = resPlanning.data;
      setPlanningOptions(planningData);

      // if (planningData.length > 0) {
      //   // Automatically select the first planning and set in inputs
      //   const firstPlanning = planningData[0];
      //   setInputs((prevInputs) => ({
      //     ...prevInputs,
      //     planning_id: firstPlanning.id, // Assuming the ID field for planning
      //   }));

      //   // Load items for the first planning
      //   handlePlanningChange(firstPlanning.id);
      // }

      // Fetch the receipt number
      // const resReceiptNo = await Http.get(
      //   "/last-code-increment-by-one/requisition_arts/receipt_no/RD"
      // );
      // const receiptNo = resReceiptNo.data; // Assuming the API returns the receipt number directly

      // // Set the fetched receipt number to inputs
      // setInputs((prevInputs) => ({
      //   ...prevInputs,
      //   receipt_no: receiptNo,
      // }));
    } catch (e) {
      console.error("Error fetching data:", e);
    }
  };

  useEffect(() => {
    $("body").addClass("collapse-menu");
    // $("body").toggleClass("show-left");
    fetchData();

    // // Set `to_department` based on `role`
    // if (role === "jigger") {
    //   setInputs((prevInputs) => ({
    //     ...prevInputs,
    //     to_department:
    //       departments.find((dept) => dept.name === "FINISHING")?.id || "",
    //   }));
    // } else if (role === "casting") {
    //   setInputs((prevInputs) => ({
    //     ...prevInputs,
    //     to_department: departments.find((dept) => dept.name === "BK")?.id || "",
    //   }));
    // }
  }, []);

  const handleAddType = (index, type) => {
    const updatedList = [...list];
    const newEntry = { type: "", qty: 0 };

    if (type === "defect") {
      updatedList[index].defects = [
        ...(updatedList[index].defects || []),
        newEntry,
      ];
    } else if (type === "repair") {
      updatedList[index].repairs = [
        ...(updatedList[index].repairs || []),
        newEntry,
      ];
    }

    setList(updatedList);
  };

  const handleTypeChange = (index, subIndex, value, type) => {
    const updatedList = [...list];
    if (type === "defect") {
      updatedList[index].defects[subIndex].type = value;
    } else if (type === "repair") {
      updatedList[index].repairs[subIndex].type = value;
    }
    setList(updatedList);
  };

  const handleQtyChange = (index, subIndex, value, type) => {
    const updatedList = [...list];
    const quantity = parseInt(value) || 0;
    if (type === "defect") {
      updatedList[index].defects[subIndex].qty = quantity;
    } else if (type === "repair") {
      updatedList[index].repairs[subIndex].qty = quantity;
    }
    setList(updatedList);
  };

  const handleRemoveType = (index, subIndex, type) => {
    const updatedList = [...list];
    if (type === "defect") {
      updatedList[index].defects.splice(subIndex, 1);
    } else if (type === "repair") {
      updatedList[index].repairs.splice(subIndex, 1);
    }
    setList(updatedList);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    checkRequiredFields();
    const formData = {
      ...inputs,
      items: list,
      production_against_requisition_art_id: id,
    };

    // ADDED: confirmation prompt before submitting
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to submit this transfer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, submit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      // if (!result.isConfirmed) return;
      if (!result.isConfirmed) {
        setIsSubmitting(false); // ADDED: reappear on cancel
        return;
      }

      Http.post(`/production-transfer`, formData)
        .then((res) => {
          navigate("/transfer-art", {
            state: { message: res.data.message, type: "success" },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    });
  };

  const handlePlanningChange = async (planningId, page = 1) => {
    // if (!planningId) return;

    setInputs((prevInputs) => ({
      ...prevInputs,
      planning_id: planningId, // Update planning_id in inputs
    }));

    try {
      // Directly fetch data from requisition-art-details endpoint
      const requisitionResponse = await Http.get(
        `/requisition-art-details/${id}`,
      );
      console.log("Requisition data:", requisitionResponse.data);

      // Extract items from the response
      const requisitionItems = requisitionResponse.data.items;

      // Map the items to the format expected by the component
      const formattedItems = requisitionItems.map((item) => ({
        id: item.id,
        product_id: item.product_id,
        planning_item_id: item.planning_item_id,
        production_work_order_item_id: item.production_work_order_item_id,
        product_name: item.product?.name,
        shape: item?.shape?.name,
        shape_id: item.shape_id,
        glaze_id: item.glaze_id,
        decoration_code: item?.decoration_code,
        decoration_name: item?.decoration_name,
        glaze_name: item?.glaze?.colour_name,
        planning_qty: item.required_qty,
        production_work_order:
          item?.production_work_order_item?.production_work_order?.receipt_no, // This might need to be fetched separately if needed
        production_work_order_id: item.production_work_order_item_id,
        company:
          item?.production_work_order_item?.production_work_order?.company
            ?.name, // This might need to be fetched separately if needed
        product_code: item.product?.code,
        weight: item.weight,
        transfer_qty: 0,
        closing_balance: item.required_qty,
        remarks_delivery: item.remarks_delivery || "",

        // Add all the necessary fields from the requisition item
        slice_weight: item.slice_weight,
        green_weight: item.green_weight,
        fg_weight: item.fg_weight,
        production_qty: item.qty,
        required_qty_export: item.required_qty_export || 0,
        required_qty_a_class: item.required_qty_a || 0,
        required_qty_b_class: item.required_qty_b || 0,
        required_qty_c_class: item.required_qty_c || 0,

        // Calculate opening balances
        ob_exp: item.qty_export - (item.delivery_qty_export || 0),
        ob_a: item.qty_a_class - (item.delivery_qty_a_class || 0),
        ob_b: item.qty_b_class - (item.delivery_qty_b_class || 0),
        ob_c: item.qty_c_class - (item.delivery_qty_c_class || 0),
        total_delivery_qty_export: item.total_delivery_qty_export || 0,
        total_delivery_qty_a_class: item.total_delivery_qty_a_class || 0,
        total_delivery_qty_b_class: item.total_delivery_qty_b_class || 0,
        total_delivery_qty_c_class: item.total_delivery_qty_c_class || 0,

        // ADDED: current stock fields
        current_stock_qty_export_class:
          Number(item.current_stock_qty_export_class) || 0,
        current_stock_qty_a_class: Number(item.current_stock_qty_a_class) || 0,
        current_stock_qty_b_class: Number(item.current_stock_qty_b_class) || 0,
        current_stock_qty_c_class: Number(item.current_stock_qty_c_class) || 0,
        current_stock_inner_qty: Number(item.current_stock_inner_qty) || 0,
        current_stock_master_qty: Number(item.current_stock_master_qty) || 0,
      }));

      // Set the list with the formatted items
      setList(formattedItems);

      // If pagination is needed, you might need to handle it differently
      // since we're not using the planning endpoint anymore
      setPagination({
        current_page: 1,
        per_page: formattedItems.length,
        total: formattedItems.length,
        last_page: 1,
      });
    } catch (error) {
      console.error("Error fetching products for planning:", error);
      Swal.fire(
        "Error!",
        "Failed to fetch products for the selected planning." + error,
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const inputValue = parseFloat(value) || 0;
    const updatedList = [...list];

    const fieldConfig = {
      export: {
        limitKey: "required_qty_export",
        stockKey: "current_stock_qty_export_class", // ADDED
        deliveryField: "delivery_qty_export",
        lossField: "after_production_loss_qty_export",
        label: "Export",
      },
      a_class: {
        limitKey: "required_qty_a_class",
        stockKey: "current_stock_qty_a_class", // ADDED
        deliveryField: "delivery_qty_a_class",
        lossField: "after_production_loss_qty_a_class",
        label: "A Class",
      },
      b_class: {
        limitKey: "required_qty_b_class",
        stockKey: "current_stock_qty_b_class", // ADDED
        deliveryField: "delivery_qty_b_class",
        lossField: "after_production_loss_qty_b_class",
        label: "B Class",
      },
      c_class: {
        limitKey: "required_qty_c_class",
        stockKey: "current_stock_qty_c_class", // ADDED
        deliveryField: "delivery_qty_c_class",
        lossField: "after_production_loss_qty_c_class",
        label: "C Class",
      },
    };

    for (const key in fieldConfig) {
      const config = fieldConfig[key];

      if (name === config.deliveryField || name === config.lossField) {
        const limit = parseFloat(updatedList[index][config.limitKey]) || 0;
        const stock = parseFloat(updatedList[index][config.stockKey]) || 0; // ADDED
        const counterpartField =
          name === config.deliveryField
            ? config.lossField
            : config.deliveryField;
        const counterpartValue =
          parseFloat(updatedList[index][counterpartField]) || 0;
        const total = inputValue + counterpartValue;

        /* artisan er 1st june er stock pawa porjonto eta temporary vabe off thakbe */

        // if (total > limit) {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Validation Error",
        //     text: `The sum of Delivery and Loss quantities cannot exceed the required quantity of ${config.label}.`,
        //   });
        //   updatedList[index][name] = 0;
        //   setList(updatedList);
        //   return;
        // } else {
        //   updatedList[index][name] = inputValue;
        //   setList(updatedList);
        //   return;
        // }

        if (total > limit) {
          Swal.fire({
            icon: "error",
            title: "Validation Error",
            text: `The sum of Delivery and Loss quantities cannot exceed the required quantity of ${config.label}.`,
          });
          updatedList[index][name] = 0;
          setList(updatedList);
          return;
        }

        // ADDED: stock check
        if (total > stock) {
          Swal.fire({
            icon: "error",
            title: "Insufficient Stock",
            text: `The sum of Delivery quantiy cannot exceed the current available stock (${stock}) of ${config.label}.`,
          });
          updatedList[index][name] = 0;
          setList(updatedList);
          return;
        }

        updatedList[index][name] = inputValue;
        setList(updatedList);
        return;

        // */

        // updatedList[index][name] = inputValue;
        // setList(updatedList);
        // return;
      }
    }

    // For any unrelated input field
    updatedList[index][name] = inputValue;
    setList(updatedList);
  };
  const cols = [{ field: "name", header: "Item" }];

  const handlePageChange = (page) => {
    if (page < 1 || page > pagination.last_page) return;
    handlePlanningChange(inputs.planning_id, page);
  };

  const renderPagination = () => {
    const { current_page, last_page } = pagination;
    const pageButtons = [];
    let startPage = Math.max(1, current_page - 2);
    let endPage = Math.min(last_page, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <button
          key={i}
          className={`btn btn-sm mx-1 ${
            i === current_page ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => handlePageChange(i)}
          disabled={i === current_page}
        >
          {i}
        </button>,
      );
    }

    return (
      <div className="d-flex align-items-center justify-content-center my-3">
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(1)}
          disabled={current_page === 1}
        >
          First
        </button>
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(current_page - 1)}
          disabled={current_page === 1}
        >
          Previous
        </button>
        {pageButtons}
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(current_page + 1)}
          disabled={current_page === last_page}
        >
          Next
        </button>
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(last_page)}
          disabled={current_page === last_page}
        >
          Last
        </button>
        <span className="mx-2">
          Page {current_page} of {last_page}
        </span>
      </div>
    );
  };
  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Deliver</h5>
        </div>
        <div className="am-pagebody  row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-12">
            <h6 className="card-body-title mg-sm-b-30">Delivery</h6>
            {/* <p>Transfer To Department {inputs.to_department}</p> */}
            <div
              className="row my-1 mb-2 fixed-header"
              style={{
                position: "sticky",
                top: "12%",
                width: "102.1%",
                marginBottom: "10px",
                zIndex: "1000",
                backgroundColor: "white",
                transition: "all 0.3s ease-in-out",
                transform: "translateY(0)",
                padding: "10px 0",
              }}
            >
              <div className="col-lg">
                <label>Receipt No</label>
                <input
                  type="text"
                  className="form-control"
                  name="receipt_no"
                  defaultValue={inputs.receipt_no}
                  disabled
                />
              </div>

              {/* <div className="col-lg">
                <label>Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  defaultValue={inputs.date}
                  disabled
                />
              </div> */}
              <div className="col-lg">
                <label>Planning</label>
                <select
                  className="form-control"
                  value={inputs.planning_id || ""} // Bind to inputs
                  onChange={(e) => handlePlanningChange(e.target.value)}
                  disabled
                >
                  {/* <option value="">Select Planning</option> */}
                  {planningOptions.map((planning) => (
                    <option key={planning.id} value={planning.id}>
                      {planning.receipt_no}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg">
                <label>
                  Shift <i className="fa fa-star required"></i>
                </label>
                <select
                  className="form-control"
                  name="shift"
                  defaultValue={inputs.shift}
                  onChange={handleChange}
                  data-required
                >
                  <option value="">Select Shift</option>
                  <option value="a">A</option>
                  <option value="b">B</option>
                  <option value="c">C</option>
                  <option value="general">General</option>
                </select>
              </div>
              <div className="col-lg">
                <label>
                  Entry Date <i className="fa fa-star required"></i>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="entry_date"
                  value={inputs.entry_date}
                  onChange={handleChange}
                  data-required
                />
              </div>

              {/* <div className="row">
                <label>Transfer To Department {inputs.to_department}</label>
                
              </div> */}

              <div className="col-lg">
                <label>Remarks</label>
                <textarea
                  className="form-control"
                  name="remarks"
                  defaultValue={inputs.remarks}
                />
              </div>
              <div className="col-lg">
                <label>
                  Status <i className="fa fa-star required"></i>
                </label>
                <select
                  className="form-control"
                  name="status"
                  value={inputs.status}
                  onChange={handleChange}
                  data-required
                >
                  <option value="incomplete">Incomplete</option>
                  <option value="complete">Complete</option>
                </select>
              </div>
              {list?.length > 0 && (
                <>
                  {!isSubmitting && (
                    <div className="col-lg mt-5">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          setIsSubmitting(true);
                          formSubmit();
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                  {isSubmitting && (
                    <div className="col-lg mt-5">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setIsSubmitting(false)}
                      >
                        Regain Submit
                      </button>
                    </div>
                  )}
                  {/* <div className="col-lg-3 mt-4">{renderPagination()}</div> */}
                </>
              )}
            </div>

            {/* Item List */}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row mt-3">
                  <div className="card-solid">
                    <div className="card-header with-border text-center">
                      <h5 className="card-title mb-0">
                        Items in the Production
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg">
                    <table className="table table-sm">
                      <thead
                        className="fixed-header"
                        style={{
                          position: "sticky",
                          top: "25%",
                          width: "104%",
                          marginBottom: "10px",
                          zIndex: "1000",
                          backgroundColor: "white",
                          transition: "all 0.3s ease-in-out",

                          transform: "translateY(0)",
                        }}
                      >
                        <tr>
                          <th>Product Name</th>
                          {/* <th>Planning Qty</th> */}
                          {role === "dfw" && <th>FG Weight</th>}
                          {/* {role === "dfw" && <th>Decoration</th>} */}
                          {/* <th>Op. Balance Exp.</th>
                      <th>Op. Balance A</th>
                      <th>Op. Balance B</th>
                      <th>Op. Balance C</th> */}
                          {/* <th>Selected Exp.</th>
                      <th>Selected A</th>
                      <th>Selected B</th>
                      <th>Selected C</th> */}

                          {/* Conditionally render table headers based on from_department_art_id */}
                          {fromDepartmentArtId === 10 ||
                          fromDepartmentArtId === 13 ? (
                            <th>Class Export</th>
                          ) : fromDepartmentArtId === 9 ||
                            fromDepartmentArtId === 12 ? (
                            <>
                              <th>Class A</th>
                              <th>Class B</th>
                              <th>Class C</th>
                            </>
                          ) : (
                            <>
                              <th>Class Export</th>
                              <th>Class A</th>
                              <th>Class B</th>
                              <th>Class C</th>
                            </>
                          )}
                          {/* <th>Cl. Balance Exp.</th>
                      <th>Cl. Balance A</th>
                      <th>Cl. Balance B</th>
                      <th>Cl. Balance C</th> */}
                        </tr>
                      </thead>
                      {/* <thead>
                    <tr>
                      <th rowSpan="2">Product Name</th>
                      <th rowSpan="2">Planning Qty</th>
                      <th colSpan="4" className="text-center">
                        Opening Balance
                      </th>
                      <th colSpan="4" className="text-center">
                        Delivery Qty
                      </th>
                      <th colSpan="4" className="text-center">
                        Closing Balance
                      </th>
                    </tr>
                    <tr>
                      <th className="text-center">Export</th>
                      <th className="text-center">A</th>
                      <th className="text-center">B</th>
                      <th className="text-center">C</th>

                      <th className="text-center">Export</th>
                      <th className="text-center">A</th>
                      <th className="text-center">B</th>
                      <th className="text-center">C</th>

                      <th className="text-center">Export</th>
                      <th className="text-center">A</th>
                      <th className="text-center">B</th>
                      <th className="text-center">C</th>
                    </tr>
                  </thead> */}

                      <tbody>
                        {list.length < 1 ? (
                          <tr>
                            <td colSpan={13} className="text-center">
                              Please add products
                            </td>
                          </tr>
                        ) : (
                          list.map((item, index) => {
                            if (
                              item.required_qty_export > 0 ||
                              item.required_qty_a_class > 0 ||
                              item.required_qty_b_class > 0 ||
                              item.required_qty_c_class > 0
                            ) {
                              const rowKey = item?.id ?? index;
                              return (
                                <tr key={index} {...getRowProps(rowKey)}>
                                  <td style={{ width: "15%" }}>
                                    {item.product_name} ({item.shape}) ||{" "}
                                    {item.company} #{item.production_work_order}
                                    <br />
                                    {item.glaze_name
                                      ? `Glaze: ${item.glaze_name}`
                                      : "Glaze: -"}{" "}
                                    <br />
                                    {role !== "selection" && (
                                      <>
                                        {item.decoration_code
                                          ? `Dec Code: ${item.decoration_code}`
                                          : "Dec Code: -"}{" "}
                                        <br />
                                        {item.decoration_name
                                          ? `Dec Name: ${item.decoration_name}`
                                          : "Dec Name: -"}{" "}
                                        <br />
                                      </>
                                    )}
                                    <b>Planning Qty:</b>{" "}
                                    {item.planning_qty || 0}
                                  </td>
                                  {/* <td></td> */}
                                  {role === "dfw" && (
                                    <td style={{ width: "7%" }}>
                                      <input
                                        type="text"
                                        onInput={(e) =>
                                          (e.target.value =
                                            e.target.value.replace(/\D/g, ""))
                                        }
                                        className="form-control"
                                        name="fg_weight"
                                        defaultValue={item.fg_weight || ""}
                                        onChange={(e) =>
                                          handleInputChange(e, index)
                                        }
                                      />
                                    </td>
                                  )}
                                  {/* {role === "dfw" && <td>{item.decoration || "DUMMY"}</td>} */}
                                  {/* <td>{item.ob_exp || 0}</td>
                                <td>{item.ob_a || 0}</td>
                                <td>{item.ob_b || 0}</td>
                                <td>{item.ob_c || 0}</td> */}

                                  {/* Conditionally render Class Export cell */}
                                  {(fromDepartmentArtId === 10 ||
                                    fromDepartmentArtId === 13 ||
                                    (fromDepartmentArtId !== 9 &&
                                      fromDepartmentArtId !== 12)) && (
                                    <td>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <strong>
                                          {" "}
                                          Required Qty:{" "}
                                          {item.required_qty_export ?? 0}{" "}
                                        </strong>
                                        {/* <strong>
                                          {" "}
                                          Transferred Qty:{" "}
                                          {item.total_delivery_qty_export ?? 0}{" "}
                                        </strong> */}
                                        {/* <strong>
                                          {" "}
                                          Remaining Qty:{" "}
                                          {item.required_qty_export - (item.total_delivery_qty_export ?? 0)}{" "}
                                        </strong> */}
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <strong>
                                          {" "}
                                          Current Stock:{" "}
                                          {item.current_stock_qty_export_class ??
                                            0}{" "}
                                        </strong>
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                        {/* <strong>
                                          Opening: {item.ob_exp || 0}
                                        </strong> */}
                                        <strong>
                                          {" "}
                                          Transferred Qty:{" "}
                                          {item.total_delivery_qty_export ??
                                            0}{" "}
                                        </strong>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control ms-2"
                                          name="delivery_qty_export"
                                          style={{ width: "50%" }}
                                          value={item.delivery_qty_export || ""}
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          }
                                          placeholder="Transfer Exp"
                                        />
                                      </div>

                                      <div className="d-flex justify-content-between align-items-center">
                                        {/* <strong>
                                          Closing:{" "}
                                          {item.ob_exp -
                                            ((item.delivery_qty_export || 0) +
                                              (item.loss_qty_export || 0))}
                                        </strong> */}
                                        <strong>
                                          {" "}
                                          Remaining Qty:{" "}
                                          {item.required_qty_export -
                                            (item.total_delivery_qty_export ??
                                              0)}{" "}
                                        </strong>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control ms-2"
                                          name="after_production_loss_qty_export"
                                          style={{ width: "50%" }}
                                          value={
                                            item.after_production_loss_qty_export
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          }
                                          placeholder="Loss Exp"
                                        />
                                      </div>
                                    </td>
                                  )}

                                  {/* Conditionally render Class A cell */}
                                  {(fromDepartmentArtId === 9 ||
                                    fromDepartmentArtId === 12 ||
                                    (fromDepartmentArtId !== 10 &&
                                      fromDepartmentArtId !== 13)) && (
                                    <td>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <strong>
                                          {" "}
                                          Required Qty:{" "}
                                          {item.required_qty_a_class ?? 0}{" "}
                                        </strong>
                                        {/* <strong>
                                          {" "}
                                          Transferred Qty:{" "}
                                          {item.total_delivery_qty_a_class ?? 0}{" "}
                                        </strong> */}
                                        {/* <strong>
                                          {" "}
                                          Remaining Qty:{" "}
                                          {item.required_qty_a_class - (item.total_delivery_qty_a_class ?? 0)}{" "}
                                        </strong> */}
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <strong>
                                          {" "}
                                          Current Stock:{" "}
                                          {item.current_stock_qty_a_class ??
                                            0}{" "}
                                        </strong>
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                        {/* <strong>Opening: {item.ob_a || 0}</strong> */}
                                        <strong>
                                          {" "}
                                          Transferred Qty:{" "}
                                          {item.total_delivery_qty_a_class ??
                                            0}{" "}
                                        </strong>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control ms-2"
                                          name="delivery_qty_a_class"
                                          style={{ width: "50%" }}
                                          value={
                                            item.delivery_qty_a_class || ""
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          }
                                          placeholder="Transfer A"
                                        />
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        {/* <strong>
                                          Closing:{" "}
                                          {item.ob_a -
                                            ((item.delivery_qty_a_class || 0) +
                                              (item.loss_qty_a_class || 0))}
                                        </strong> */}
                                        <strong>
                                          {" "}
                                          Remaining Qty:{" "}
                                          {item.required_qty_a_class -
                                            (item.total_delivery_qty_a_class ??
                                              0)}{" "}
                                        </strong>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control ms-2"
                                          name="after_production_loss_qty_a_class"
                                          style={{ width: "50%" }}
                                          value={
                                            item.after_production_loss_qty_a_class
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          }
                                          placeholder="Loss A"
                                        />
                                      </div>
                                    </td>
                                  )}
                                  {/* Conditionally render Class B cell */}
                                  {(fromDepartmentArtId === 9 ||
                                    fromDepartmentArtId === 12 ||
                                    (fromDepartmentArtId !== 10 &&
                                      fromDepartmentArtId !== 13)) && (
                                    <td>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <strong>
                                          {" "}
                                          Required Qty:{" "}
                                          {item.required_qty_b_class ?? 0}{" "}
                                        </strong>
                                        {/* <strong>
                                          {" "}
                                          Transferred Qty:{" "}
                                          {item.total_delivery_qty_b_class ?? 0}{" "}
                                        </strong> */}
                                        {/* <strong>
                                          {" "}
                                          Remaining Qty:{" "}
                                          {item.required_qty_b_class - (item.total_delivery_qty_b_class ?? 0)}{" "}
                                        </strong> */}
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <strong>
                                          {" "}
                                          Current Stock:{" "}
                                          {item.current_stock_qty_b_class ??
                                            0}{" "}
                                        </strong>
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                        {/* <strong>Opening: {item.ob_b || 0}</strong> */}
                                        <strong>
                                          {" "}
                                          Transferred Qty:{" "}
                                          {item.total_delivery_qty_b_class ??
                                            0}{" "}
                                        </strong>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control ms-2"
                                          name="delivery_qty_b_class"
                                          style={{ width: "50%" }}
                                          value={
                                            item.delivery_qty_b_class || ""
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          }
                                          placeholder="Transfer B"
                                        />
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        {/* <strong>
                                          Closing:{" "}
                                          {item.ob_b -
                                            ((item.delivery_qty_b_class || 0) +
                                              (item.loss_qty_b_class || 0))}
                                        </strong> */}
                                        <strong>
                                          {" "}
                                          Remaining Qty:{" "}
                                          {item.required_qty_b_class -
                                            (item.total_delivery_qty_b_class ??
                                              0)}{" "}
                                        </strong>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control ms-2"
                                          name="after_production_loss_qty_b_class"
                                          style={{ width: "50%" }}
                                          value={
                                            item.after_production_loss_qty_b_class
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          }
                                          placeholder="Loss B"
                                        />
                                      </div>
                                    </td>
                                  )}
                                  {/* Conditionally render Class C cell */}
                                  {(fromDepartmentArtId === 9 ||
                                    fromDepartmentArtId === 12 ||
                                    (fromDepartmentArtId !== 10 &&
                                      fromDepartmentArtId !== 13)) && (
                                    <td>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <strong>
                                          {" "}
                                          Required Qty:{" "}
                                          {item.required_qty_c_class ?? 0}{" "}
                                        </strong>
                                        {/* <strong>
                                          {" "}
                                          Transferred Qty:{" "}
                                          {item.total_delivery_qty_c_class ?? 0}{" "}
                                        </strong> */}
                                        {/* <strong>
                                          {" "}
                                          Remaining Qty:{" "}
                                          {item.required_qty_c_class - (item.total_delivery_qty_c_class ?? 0)}{" "}
                                        </strong> */}
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <strong>
                                          {" "}
                                          Current Stock:{" "}
                                          {item.current_stock_qty_c_class ??
                                            0}{" "}
                                        </strong>
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                        {/* <strong>Opening: {item.ob_c || 0}</strong> */}
                                        <strong>
                                          {" "}
                                          Transferred Qty:{" "}
                                          {item.total_delivery_qty_c_class ??
                                            0}{" "}
                                        </strong>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control ms-2"
                                          name="delivery_qty_c_class"
                                          style={{ width: "50%" }}
                                          value={
                                            item.delivery_qty_c_class || ""
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          }
                                          placeholder="Transfer C"
                                        />
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        {/* <strong>
                                          Closing:{" "}
                                          {item.ob_c -
                                            ((item.delivery_qty_c_class || 0) +
                                              (item.loss_qty_c_class || 0))}
                                        </strong> */}
                                        <strong>
                                          {" "}
                                          Remaining Qty:{" "}
                                          {item.required_qty_c_class -
                                            (item.total_delivery_qty_c_class ??
                                              0)}{" "}
                                        </strong>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control ms-2"
                                          name="after_production_loss_qty_c_class"
                                          style={{ width: "50%" }}
                                          value={
                                            item.after_production_loss_qty_c_class
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          }
                                          placeholder="Loss C"
                                        />
                                      </div>
                                    </td>
                                  )}
                                  {/* <td>
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control"
                                    name="delivery_qty_export"
                                    defaultValue={item.delivery_qty_export}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="Transfer Export"
                                  />
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control"
                                    name="loss_qty_export"
                                    defaultValue={item.loss_qty_export}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="Loss Export"
                                  />
                                </td> */}
                                  {/* <td>
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control"
                                    name="delivery_qty_a_class"
                                    defaultValue={item.delivery_qty_a_class}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="Transfer A"
                                  />
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control"
                                    name="loss_qty_a_class"
                                    defaultValue={item.loss_qty_a_class}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="Loss A"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control"
                                    name="delivery_qty_b_class"
                                    defaultValue={item.delivery_qty_b_class}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="Transfer B"
                                  />
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control"
                                    name="loss_qty_b_class"
                                    defaultValue={item.loss_qty_b_class}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="Loss B"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control"
                                    name="delivery_qty_c_class"
                                    defaultValue={item.delivery_qty_c_class}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="Transfer C"
                                  />
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control"
                                    name="loss_qty_c_class"
                                    defaultValue={item.loss_qty_c_class}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="Loss C"
                                  />
                                </td>
                                <td>
                                  {item.ob_exp - item.delivery_qty_export ||
                                    item.ob_exp}
                                </td>
                                <td>
                                  {item.ob_a - item.delivery_qty_a_class || item.ob_a}
                                </td>
                                <td>
                                  {item.ob_b - item.delivery_qty_b_class || item.ob_b}
                                </td>
                                <td>
                                  {item.ob_c - item.delivery_qty_c_class || item.ob_c}
                                </td> */}
                                </tr>
                              );
                            }
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}

            {/* {list.length > 0 && (
              <div className="row mt-3">
                <div className="col-3">
                  <button className="btn btn-primary" onClick={formSubmit}>
                    Submit
                  </button>
                </div>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
